var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBindMail = function SvgBindMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bindMail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v900H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bindMail_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4.888v11.738C24 17.932 22.92 19 21.6 19H2.4C1.08 19 0 17.932 0 16.626L.011 4.893l11.702 6.32a.599.599 0 0 0 .574 0L24 4.888ZM21.6 0c1.31 0 2.383 1.054 2.4 2.346L12.004 8.981.011 2.354A2.385 2.385 0 0 1 2.401 0H21.6Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bindMail_svg__a)",
    transform: "translate(-456 -409)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bindMail_svg__b)",
    transform: "translate(460 416)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A63F1",
    d: "M0 0h24v19H0V0z"
  })))));
};
export default SvgBindMail;